import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { trackPage } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Portfolio from "@/pages/Portfolio";
import PortfolioDetail from "@/pages/PortfolioDetail";
import Process from "@/pages/Process";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminLeads from "@/pages/admin/Leads";
import AdminLeadDetail from "@/pages/admin/LeadDetail";
import AdminPortfolio from "@/pages/admin/PortfolioAdmin";
import AdminSettings from "@/pages/admin/Settings";

function useLenis() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let raf;
        const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
        raf = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(raf); lenis.destroy(); };
    }, []);
}

function Shell() {
    const location = useLocation();
    const isAdmin = location.pathname.startsWith("/admin");
    useLenis();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!isAdmin) trackPage(location.pathname);
    }, [location.pathname, isAdmin]);

    return (
        <div className="min-h-screen bg-hive-bg text-slate-100 grain">
            {!isAdmin && <Navbar />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceDetail />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
                <Route path="/process" element={<Process />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                    <Route index element={<AdminDashboard />} />
                    <Route path="leads" element={<AdminLeads />} />
                    <Route path="leads/:id" element={<AdminLeadDetail />} />
                    <Route path="portfolio" element={<AdminPortfolio />} />
                    <Route path="settings" element={<AdminSettings />} />
                </Route>
                <Route path="*" element={<Home />} />
            </Routes>
            {!isAdmin && <Footer />}
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Shell />
                <Toaster theme="dark" richColors position="top-right" />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
